export default __webpack_public_path__ + "static/media/aPenzugyiForrasokrol.c35f419c.png";